import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";

const LOGO_SQ = "https://customer-assets.emergentagent.com/job_vinyl-scouts/artifacts/dfa6la5v_TPRESSLOGOSQ.png";

export function Header({ onSubmitClick }) {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleSubmitClick = () => {
    if (isHome && onSubmitClick) {
      onSubmitClick();
    } else {
      window.location.href = "/#submit-form";
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-zinc-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 h-28 flex items-center justify-between">
        <Link to="/" className="flex items-center" data-testid="logo-link">
          <img
            src={LOGO_SQ}
            alt="Test Press Club"
            className="h-24 w-auto"
          />
        </Link>
        <div className="flex items-center gap-4">
          <Link
            to="/pro"
            className="text-zinc-600 hover:text-black text-sm uppercase tracking-wider font-bold transition-colors duration-300 hidden sm:block"
            data-testid="nav-pro-link"
          >
            Pro Access
          </Link>
          <Link
            to="/publishing"
            className="text-zinc-600 hover:text-black text-sm uppercase tracking-wider font-bold transition-colors duration-300 hidden sm:block"
            data-testid="nav-publishing-link"
          >
            Publishing
          </Link>
          <Link
            to="/dj-list"
            className="text-zinc-600 hover:text-black text-sm uppercase tracking-wider font-bold transition-colors duration-300 hidden sm:block"
            data-testid="nav-dj-link"
          >
            Join the DJ List
          </Link>
          <Button
            onClick={handleSubmitClick}
            className="bg-black text-white hover:bg-zinc-800 rounded-none uppercase font-bold tracking-wider px-6 py-2 transition-colors duration-300 border border-black"
            data-testid="nav-submit-btn"
          >
            Submit
          </Button>
        </div>
      </div>
    </nav>
  );
}
